import { render } from "./ModalCustomForm.vue?vue&type=template&id=394b901c"
import script from "./ModalCustomForm.vue?vue&type=script&lang=js"
export * from "./ModalCustomForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__